// extracted by mini-css-extract-plugin
export const sectionSpacing = "auth-forms-module--section-spacing--T2uon";
export const rowSpacing = "auth-forms-module--row-spacing--3PlIY";
export const rowSpacingSml = "auth-forms-module--row-spacing-sml--2ExG4";
export const formField = "auth-forms-module--formField--2DntW";
export const formButton = "auth-forms-module--formButton--vVr6w";